import { connect } from 'react-redux'
import Dashboard from './components/App/Dashboard'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth, root: state.root, referralList: state.referralList }), mapDispatchToProps)(Dashboard)
